export default __webpack_public_path__ + "static/media/EmptySalesImage.14f58c18.png";